import React, { useState, useEffect, useRef } from 'react';
import { Close } from '@mui/icons-material';
import { Search as SearchIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import './Search.css';

const Search = ({ searchData, showDetails }) => {
  const [query, setQuery] = useState('');
  const [results, setResults] = useState([]);
  const [showResults, setShowResults] = useState(false);
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setShowResults(false);
    }
  };

  const handleSearch = (e) => {
    const query = e.target.value;
    setQuery(query);

    if (query.length === 0) {
      setResults([]);
      setShowResults(false);
      return;
    }

    const matchingResults = searchData.filter((result) => {
      return Object.values(result).some((value) =>
        value.toString().toLowerCase().includes(query.toLowerCase())
      );
    });

    setResults(matchingResults);
    setShowResults(true);
  };

  const handleClear = () => {
    setQuery('');
    setResults([]);
    setShowResults(false);
  };

  const handleResultClick = (result) => {
    setQuery('');
    setResults([]);
    setShowResults(false);
    showDetails(result._id);
  };

  return (
    <div className="relative w-[80%] 2xl:w-[50%]" ref={dropdownRef}>
      <div className="flex items-center border border-gray-300 rounded-[50px] p-2 bg-[#f9f9f9]">
        <SearchIcon />
        <input
          type="text"
          placeholder="Search Cell"
          value={query}
          onChange={handleSearch}
          className="outline-none ml-2 bg-[#f9f9f9] w-full"
        />
        {query && (
          <button className="cursor-pointer background-transparent border-none" onClick={handleClear}>
            <Close />
          </button>
        )}
      </div>
      {showResults && (
        <div className="absolute top-[50px] left-0 w-full bg-[white] border border-gray-300 rounded-b-lg z-50 max-h-36 overflow-y-auto">
          {results.length > 0 ? (
            results.map((result, index) => (
              <div
                key={index}
                className="result-item"
                onClick={() => handleResultClick(result)}
              >
                {result.manufacturer} - {result.model} - {result.capacity}
              </div>
            ))
          ) : (
            <div className="result-item">No Matching Results</div>
          )}
        </div>
      )}
    </div>
  );
};

export default Search;
